import { setUsrAppRefreshParams } from '@jfs/network'
import { Box, ButtonNew, ColorOptions, EmptyView, Icon, Image, SpacerNew, Text } from '@jfs/ui-new'
import { TextInput } from '@jfs/ui-new/src/comps/TextInputNew'
import { getErrorMessage } from '@jfs/utils'
import { useNavigation } from '@react-navigation/core'
import { useFocusEffect } from '@react-navigation/native'
import { useCallback, FC, useEffect, useState } from 'react'
import { FlatList, Keyboard, TouchableOpacity } from 'react-native'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { AppHeaderTransformerAgent, extendAppSession } from '../../../network/extendAppSession'
import { extendUserSession, HeaderTransformerAgentPortal } from '../../../network/extendUserSession'
import { isSessionValid } from '../../../util/util'

const MidList: FC = () => {
  const {
    getMidsQrList,
    getQrList,
    userMobileNo,
    sessUsrAccessToken,
    sessUsrRefreshToken,
    sessAppAccessToken,
    sessAppRefreshToken,
    isActivationDone,
    updateActivation,
    logout,
    resetAccessToken,
    setInitialized,
    sessionData,
  } = useStores((store) => ({
    getMidsQrList: store.agentQrUser.getMidsQrList,
    getQrList: store.agentQrUser.getQrList,
    midListLength: store.agentQrUser.midList.length,
    userMobileNo: store?.agentQrUser?.mobile,
    sessUsrAccessToken: store?.agentQrSession?.userAccessToken,
    sessUsrRefreshToken: store?.agentQrSession?.userRefreshToken,
    sessionData: store?.agentQrSession,
    sessAppAccessToken: store?.agentQrSession?.appAccessToken,
    sessAppRefreshToken: store?.agentQrSession?.appRefreshToken,
    isActivationDone: store?.agentQrConfig?.isActivationDone,
    updateActivation: store.agentQrConfig.updateActivation,
    logout: store.agentQrUser.logout,
    resetAccessToken: store.agentQrSession.resetAccessToken,
    setInitialized: store.agentQrSession.setInitialized,
  }))
  const navigation = useNavigation()
  //const isFocused = useIsFocused()

  useEffect(() => {
    setUsrAppRefreshParams(
      () => extendUserSession(userMobileNo, sessUsrAccessToken, sessUsrRefreshToken, true),
      HeaderTransformerAgentPortal,
      () => extendAppSession(sessAppAccessToken, sessAppRefreshToken),
      AppHeaderTransformerAgent,
    )
  }, [sessAppAccessToken, sessAppRefreshToken, sessUsrAccessToken, sessUsrRefreshToken, userMobileNo])

  const [data, setData] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const [callGetList, getListHandler] = useLazyApiData(getMidsQrList)
  const [callLogout, logoutHandler] = useLazyApiData(logout)

  useEffect(() => {
    const sessData = window?.localStorage.getItem('csoSessData')
    if (!sessData && !isSessionValid(sessionData)) {
      navigation?.reset({
        index: 0,
        routes: [{ name: Routes.QrAgentLogin }],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData, sessAppAccessToken])

  useFocusEffect(
    useCallback(() => {
      const data = getQrList('')
      if (data.length === 0 || isActivationDone) {
        callGetList()
      } else {
        setData(data)
      }
    }, [callGetList, getQrList, isActivationDone]),
  )

  useEffect(() => {
    if (getListHandler.state === 'fulfilled') {
      setData(getQrList(''))
    }
  }, [getListHandler.state, getQrList])

  useEffect(() => {
    if (logoutHandler.state === 'fulfilled' || logoutHandler.state === 'rejected') {
      resetAccessToken()
      navigation.reset({
        index: 0,
        routes: [
          {
            name: Routes.QrAgentLogin,
          },
        ],
      })
    }
  }, [logoutHandler.state, navigation, resetAccessToken])

  useEffect(() => {
    setInitialized(true)
    const csoSessData = window.localStorage.getItem('csoSessData')
    if (!csoSessData || csoSessData?.length === 0 || !isSessionValid(csoSessData)) {
      navigation.reset({
        index: 0,
        routes: [{ name: Routes.QrAgentLogin }],
      })
      resetAccessToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderItem = ({ item }: any) => {
    const onPressIn = () => {
      updateActivation(false)
      Keyboard.dismiss()
    }
    const onActivatePress = () => {
      console.log('item', item)

      navigation.navigate(Routes.scanqr, { data: item })
    }

    return (
      <Box
        alignSelf="stretch"
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        minHeight={86}
        padding={24}>
        <Box f={1}>
          <Text fontFamily="jiotype-bold" fontSize={14} color={'BLACK_21'} ellipsizeMode="tail" numberOfLines={1}>
            {item.name}
          </Text>
          <SpacerNew size={8} direction={'vertical'} />
          <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
            {`MID: ${item.id}`}
          </Text>
          <SpacerNew size={8} direction={'vertical'} />
          <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_75'}>
            {`Terminal id: ${item.tid}`}
          </Text>
        </Box>
        <TouchableOpacity testID="onActivatePress" onPressIn={onPressIn} onPressOut={onActivatePress}>
          <Box
            justifyContent={'center'}
            flexDirection={'row'}
            borderColor={'#0070B6' as ColorOptions}
            borderWidth={1}
            height={34}
            width={108}
            underlayColor={'GRAY_SHADOW'}
            paddingVertical={8}
            borderRadius={8}
            backgroundColor={'WHITE'}>
            <Text color={'#0070B6' as ColorOptions} fontFamily={'jiotype-medium'} fontSize={12}>
              {'Activate'}
            </Text>
            <SpacerNew size={8} direction={'horizontal'} />
            <Icon size={16} id={'SCAN_QR'} color={'#0070B6' as ColorOptions} />
          </Box>
        </TouchableOpacity>
      </Box>
    )
  }

  const separator = () => {
    return <Box bg={'#0000001F' as ColorOptions} h={1} />
  }

  // const onSearch = () => {
  //   const searchData = getQrList(searchValue)
  //   setData(searchData)
  // }

  const onChangeText = (text: string) => {
    setSearchValue(text)
    const searchData = getQrList(text)
    setData(searchData)
  }

  const handleLogout = () => {
    callLogout()
  }

  const errorState = getErrorMessage([getListHandler])

  return (
    <Box bg={'WHITE'}>
      <Box flexDirection={'row'} w={'100%'} justifyContent={'space-between'} alignItems="center">
        <Box h={56} alignItems={'flex-start'} justify={'center'} marginTop={8} padding={24}>
          <Image source={require('../../../assets/images/all-in-one-qr/jiopaybuzz.png')} height={32} width={143} />
        </Box>
        <ModBox alignItems={'center'} marginRight={24}>
          <ButtonNew
            color={'#0070B6' as ColorOptions}
            height={32}
            titleColor={'WHITE'}
            title={'Logout'}
            testID="logout"
            onPress={handleLogout}
          />
        </ModBox>
      </Box>
      <Box borderBottomWidth={1} borderBottomColor={'#0000001F' as ColorOptions} />
      <Box marginTop={24} paddingHorizontal={24}>
        <Text fontFamily="jiotype-black" fontSize={18} color={'BLACK_75'}>
          {'MIDs for QR Activation'}
        </Text>
        <Box h={40} marginVertical={32}>
          <TextInput
            leftComponent={<Icon id={'SEARCH'} size={16} color={'BLACK_75'} />}
            value={searchValue}
            onChangeText={onChangeText}
            padding={12}
            borderColor={'#0000001F' as ColorOptions}
            placeholder="Search MID or Business Name"
            focusBorderColor={'#0070B6' as ColorOptions}
            labelColor={'BLACK_21'}
          />
        </Box>
      </Box>
      <EmptyView
        loadingMessage="Loading..."
        onRetry={callGetList}
        isLoading={getListHandler.state === 'pending'}
        error={errorState}
        emptyMessage={data.length === 0 ? 'No data found' : ''}
      />
      <FlatList data={data} renderItem={renderItem} ItemSeparatorComponent={separator} />
    </Box>
  )
}

export { MidList as default }
